import { get } from './httpClient';
import type { Employee, UserInfo } from '../types';

export const employeeService = {
  // Get all employees
  getAllEmployees: async (): Promise<Employee[]> => {
    const response = await get<{ Items: Employee[] }>('/db/employees/employee_id,email,name,admin/None');
    return response.data.Items;
  },

  // Get employee by email
  getByEmail: async (email: string): Promise<UserInfo> => {
    const response = await get<{ Item: Employee }>(`/db/employees/email/${email}`);
    const employee = response.data.Item;
    return {
      employee_id: employee.employee_id.N,
      admin: employee.admin.BOOL,
      name: employee.name?.S || '',
      email: email,
    };
  },

  // Get employee by ID
  getById: async (employeeId: string): Promise<Employee> => {
    const response = await get<{ Item: Employee }>(`/db/employees/employee_id/${employeeId}`);
    return response.data.Item;
  },
};
